import { Component } from '@angular/core';

@Component({
    selector: 'masthead-overlay',
    templateUrl: './masthead-overlay.component.html',
    standalone: false
})

export class MastheadOverlayComponent{ }
